import { Disclosure } from '@headlessui/react';
import { GoDash, GoPlus } from "react-icons/go";
import MapSection from "./mapSection.js";
import { useEffect } from 'react';
import KeywordFilter from "./Filters/keywordFilter.js";
import ResearchPlatformFilter from "./Filters/researchPlatformFilter.js";
import PublicationYearFilter from "./Filters/publicationYearFilter.js";
import DurationFilter from "./Filters/durationFilter.js";
import PublisherFilter from "./Filters/publisherFilter.js";
import { populateLocalStorage } from "../../Common/filtersLocalStorage"

/**
 * Displays the filter section.
 *
 * @param {*} props Contains 'filters' state variable & 'setFilters' state method.
 */
export default function FilterSection(props) {

  const filterComponents = [
    { componentName: KeywordFilter, title: "Keywords", defaultOpen: props.filters.keywords.length },
    { componentName: ResearchPlatformFilter, title: "Research Platform", defaultOpen: props.filters.researchPlatform.length },
    { componentName: PublicationYearFilter, title: "Publication Year", defaultOpen: props.filters.publicationYear },
    { componentName: DurationFilter, title: "Duration", defaultOpen: props.filters.duration.start || props.filters.duration.end },
    { componentName: PublisherFilter, title: "Publisher", defaultOpen: props.filters.publisher.length }
  ];


  useEffect(() => {
    populateLocalStorage();
  }, []);


  /**
   * Displays specified filter component.
   *
   * @param {*} filterComponentName Name of the component to be displayed.
   * @returns React Component.
   */
  function renderFilterContents(filterComponentName) {
    const Component = filterComponentName;
    return <Component {...props} setParam={setParam} removeParam={removeParam} />;
  }

  /**
   * Sets a URL parameter.
   *
   * @param {String} name Name of the parameter to be set.
   * @param {*} data Value to set parameter to.
   */
  function setParam(name, data) {
    const url = new URL(window.location.href);
    url.searchParams.set(name, data);
    window.history.replaceState(null, null, url);
  }

  /**
   * Remove a parameter from the URL.
   *
   * @param {String} name Name of the parameter to remove.
   */
  function removeParam(name) {
    const url = new URL(window.location.href);
    url.searchParams.delete(name);
    window.history.replaceState(null, null, url);
  }

  return (
    <>
      <h3 className="sr-only">Filters</h3>
      <MapSection {...props} setParam={setParam} removeParam={removeParam}/>
      {/* Iterates through filterComponents object to create each filter section */}
      {filterComponents.map((filterComponent, index) => {
        return (
          <Disclosure key={index} defaultOpen={filterComponent.defaultOpen} as="div" className="border-b border-gray-300 py-6 px-3 dark:border-gray-700">
            {({ open }) => (
              <>
                <h3 className="-my-3 flow-root">
                  <Disclosure.Button data-cy={filterComponent.title} className="py-3 w-full flex items-center justify-between text-sm text-gray-400 hover:text-gray-500 focus:outline-none">
                    <span className="font-medium text-gray-900 text-base dark:text-white">{filterComponent.title}</span>
                    <span className="ml-6 flex items-center">
                      {open ? (
                        <GoDash className="h-3.5 w-3.5" aria-hidden="true" />
                      ) : (
                        <GoPlus className="h-3.5 w-3.5" aria-hidden="true" />
                      )}
                    </span>
                  </Disclosure.Button>
                </h3>
                <Disclosure.Panel className="pt-6">
                  <div className="space-y-4">
                    {renderFilterContents(filterComponent.componentName)}
                  </div>
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        );
      })}
    </>
  )
}
